// import request from 'modules/rest/api/request'
//
// export default function login(login, password) {
//   /* TODO: Should I get url to get token from special function
//    * from outside api? For example:
//    *
//    * import paths from 'paths'
//    * paths.authGetToken
//    * */
//   return request(`/auth/token`, {}, {
//     method: `POST`,
//     body  : {
//       login,
//       password,
//     },
//   })
// }
//
export default null
